const data = [
  {
    company: {
      name: "DataRobot",
      link: "https://www.datarobot.com/",
      location: "Remote"
    },
    info: {
      title: "iOS Engineer",
      from: "Jan-2021",
      to: "till date",
      highlights: "DataRobot Enterprise App for iOS & Android, Spam SMS Detector for Android (AI)"
    }
  },
  {
    company: {
      name: "Turvo Inc.",
      link: "https://www.turvo.com/",
      location: "Hyderabad, India"
    },
    info: {
      title: "Sr. iOS App Developer",
      from: "Jan-2018",
      to: "Dec-2020",
      highlights: "Turvo Enterprise App for iOS"
    }
  },
  {
    company: {
      name: "Altimetrik",
      link: "https://www.datarobot.com/",
      location: "Pune & Banglore & Woonsocket-RI"
    },
    info: {
      title: "Lead iOS App Developer",
      from: "Aug-2015",
      to: "Dec-2017",
      highlights: "Mastercard, CVS health, Isha Foundation"
    }
  },
  {
    company: {
      name: "UST Global",
      link: "http://www.ust-global.com/en/",
      location: "Bangalore, India"
    },
    info: {
      title: "System Analyst",
      from: "May-2014",
      to: "Aug-2015",
      highlights: "Bwin, Jawfish games, Ivy Comptech"
    }
  },
  {
    company: {
      name: "Helios Solutions",
      link: "http://www.heliossolutions.in/",
      location: "Baroda, India"
    },
    info: {
      title: "Lead Application Developer",
      from: "Feb-2013",
      to: "Apr-2014",
      highlights: "Texel Points, xWare42"
    }
  },
  {
    company: {
      name: "Valtech",
      link: "http://www.valtech.com/",
      location: "Bangalore, India"
    },
    info: {
      title: "iOS Application Developer",
      from: "Oct-2011",
      to: "Jul-2012",
      highlights: "A2Z Databases, SalesGenie"
    }
  },
  {
    company: {
      name: "Digicorp",
      link: "https://www.digi-corp.com",
      location: "Ahmedabad, India"
    },
    info: {
      title: "iOS Application Developer",
      from: "Feb-2010",
      to: "Oct-2011",
      highlights: "Cinescape, Al-Watan TV"
    }
  },
  {
    company: {
      name: "Hidden Brains",
      link: "https://www.hiddenbrains.com",
      location: "Ahmedabad, India"
    },
    info: {
      title: "iOS Application Developer",
      from: "Jul-2009",
      to: "Jan-2010",
      highlights: "Qopel, Court Finder"
    }
  }
];

export default data;